var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGame = function SvgGame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.708 10.992A7 7 0 1114 6.29v-.547a3 3 0 01.362-1.429 9 9 0 106.35 6.423c-.376.167-.789.256-1.212.256h-.792z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.08 8.195a3.002 3.002 0 00-.423.43l-1.982 2.479A2.987 2.987 0 009 13a2.986 2.986 0 00.879 2.121 3 3 0 004.01.21l2.485-1.988c.157-.126.302-.268.43-.422l.187-.224a5 5 0 11-4.688-4.688l-.224.186z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4a1 1 0 00-1.657-.754l-2 1.742a1 1 0 00-.343.754v1.79l-2.64 2.2a1.003 1.003 0 00-.14.143l-2 2.5a1 1 0 001.405 1.406l2.5-2c.052-.042.1-.09.143-.14l2.207-2.649H19.5a1 1 0 00.8-.4l1.5-2a1 1 0 00-.8-1.6h-1V4z"
  }))));
};
export default SvgGame;